module.exports = __webpack_public_path__ + "media/images/svg/instagram-60e63329858763916cb383c6a0ed83cb.svg";